import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/flexible'
import javaBack from '@/utils/javaBack'
import VConsole from 'vconsole'
import Vant from 'vant';
import javaGet from '@/utils/javaGet'
import managementEvents from '@/utils/managementEvents'
import 'vant/lib/index.css';
const isDev = process.env.NODE_ENV === 'development'
// 本地环境和测试环境
if (isDev) {
  // eslint-disable-next-line no-new
  new VConsole()
}
Vue.prototype.$javaBack = javaBack
Vue.prototype.$javaGet = javaGet
Vue.use(Vant)
Vue.use(managementEvents)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
